export default __webpack_public_path__ + "static/media/clipboard.d6f8eca8.png";